import { render } from "./MonitoredIcon.vue?vue&type=template&id=0bdc4105"
import script from "./MonitoredIcon.vue?vue&type=script&lang=js"
export * from "./MonitoredIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__